import { render, staticRenderFns } from "./ChangePlanBtn.vue?vue&type=template&id=1a8df408&scoped=true&"
import script from "./ChangePlanBtn.vue?vue&type=script&lang=ts&"
export * from "./ChangePlanBtn.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePlanBtn.vue?vue&type=style&index=0&id=1a8df408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8df408",
  null
  
)

export default component.exports